export const HistoryEventObjectTypeVals = {
    ProjectDocFolder: 1,
    ProjectDoc: 2,
    Project: 3,
};